import type { NavItem } from "@voxmedia/duet-context/context/global-data-context";

/** CSK drawer labels shortened to fit mobile slide-out nav. */
const DRAWER_TITLE_OVERRIDES: Readonly<Record<string, string>> = {
  "Verge Product Updates": "Product Updates",
};

function mapDrawerNavItem(item: NavItem): NavItem {
  const title = DRAWER_TITLE_OVERRIDES[item.title] ?? item.title;

  return {
    ...item,
    title,
    ...(item.subItems
      ? {
          subItems: item.subItems.map((subItem) => ({
            ...subItem,
            title: DRAWER_TITLE_OVERRIDES[subItem.title] ?? subItem.title,
          })),
        }
      : {}),
  };
}

/** Applies CSK drawer nav label overrides to CMS `mainNav` items. */
export function getCskDrawerNavItems(
  mainNav: NavItem[] | null | undefined,
): NavItem[] {
  return (mainNav ?? []).map(mapDrawerNavItem);
}
